import {BroadcastChannel, BroadcastChannelOptions, EventContext, OnMessageHandler} from 'broadcast-channel';

/**
 * The service that handles all the static broadcast channel functionalities.
 */
class BroadcastService {
    /**
     * The names of the available channels of this service.
     */
    static readonly channelNames = {
        userTokenExpired: "user-token-expired",
        colorThemeFetched: "color-theme-fetched",
        nexusSearchConfigs: "nexus-search-configs",
        nexusSearchAdvancedSearch: "nexus_search_advanced_search",
        nexusSearchCriteria: "nexus_search_criteria",
        appBarSearchMode: "app_bar_search_mode",
        dashboards: "dashboards",
        selectedDimensionMetrics: "selected-dimension-metrics",
        authBlockerService: "auth-blocker-service",
        authBlockerDialog: "auth-blocker-dialog",
        personalPanelSettings: "personal-panel-settings",
        PanelLayoutSettings: "panel-layout-settings",
        contactUsMessagesUnreadCount: "contact-us-messages-unread-count",
    }


    /**
     * Creates a new broadcast channel with the provided name and options.
     * @param {string} channelName
     * @param {BroadcastChannelOptions?} options
     */
    static newBroadcastChannel(channelName: string, options?: BroadcastChannelOptions): BroadcastChannel<any> {
        return new BroadcastChannel<any>(channelName, options);
    }

    /**
     * Posts a singular message to the given channel name with the given args.
     *
     * @param {keyof BroadcastService.channelNames | string} channelName
     * @param {any} args
     */
    static postMessage(channelName: string, args: any): boolean {
        try {
            const bc = new BroadcastChannel(channelName);
            bc.postMessage(args).then(() => {
                bc.close().then();
            });
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * Adds an event listener for the given channel name and returns its cleanup function.
     *
     * @param {string} channelName
     * @param {EventContext} type
     * @param {OnMessageHandler<any>} listener
     */
    static addEventListener(channelName: string, type: EventContext, listener: OnMessageHandler<any>): {
        resultFlag: boolean,
        close: Function
    } {
        try {
            const bc = new BroadcastChannel(channelName);
            bc.addEventListener(type, listener);
            return {
                resultFlag: true,
                close: () => bc.close()
            };
        } catch (e) {
            return {
                resultFlag: false,
                close: () => false,
            };
        }
    }
}

export default BroadcastService;

